import { Skeleton, SkeletonLines } from "components/new-stuff/ui/Skeleton"
import CustomCard from "components/new-stuff/ui/CustomCard"
import WalletTransactionsTable from "../crossBorder/transactions/component/Table"

/**
 * The wallet dashboard, drawn before the wallet has loaded.
 *
 * These pages cannot render until the wallet arrives, because it decides
 * between two different screens: the dashboard for an onboarded wallet, and
 * the set-up screen for one that is not. So the page has to wait. It used to
 * wait behind the generic page skeleton, then snap into this layout.
 *
 * This draws the dashboard instead, since that is what nearly everyone lands
 * on: the balance card and account details in the same five-column grid, the
 * Quick Send card at its fixed height, and the recent transactions in the real
 * transactions table's own skeleton, so its rows hand over without moving.
 */
export const WalletDashboardSkeleton = () => (
  <div
    className="gap-6 flex flex-col"
    aria-busy="true"
  >
    <div>
      <Skeleton
        width="72px"
        className="mb-2"
      />
      <div className="flex flex-col xl:grid grid-cols-5 gap-4 lg:gap-7">
        {/* Balance card: dark in the real page, so a darker block here. */}
        <div className="col-span-3 min-h-[220px] rounded-5px bg-neutral20 px-4 lg:px-12 py-8 flex flex-col justify-center gap-4">
          <Skeleton width="120px" />
          <Skeleton
            width="220px"
            height="44px"
            variant="block"
          />
          <div className="flex items-center gap-2 mt-2">
            <Skeleton
              width="112px"
              height="36px"
              variant="block"
            />
            <Skeleton
              width="112px"
              height="36px"
              variant="block"
            />
          </div>
        </div>

        {/* Account details. */}
        <div className="col-span-2 border border-neutral20 bg-white p-5 rounded-5px flex flex-col gap-4">
          <Skeleton width="140px" />
          <SkeletonLines lines={4} />
        </div>
      </div>
    </div>

    <div className="h-[194px]">
      <CustomCard
        title="Quick Send"
        rootClassName="h-full !px-0"
        headerClassName="px-4 border-b border-[#F0F2F5]"
      >
        <div className="flex gap-6 px-4 py-4">
          {Array.from({ length: 4 }, (_, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-2"
            >
              <Skeleton variant="circle" />
              <Skeleton width="56px" />
            </div>
          ))}
        </div>
      </CustomCard>
    </div>

    <CustomCard title="Recent Transactions">
      <WalletTransactionsTable
        transactionsData={[]}
        loading
      />
    </CustomCard>
  </div>
)

export default WalletDashboardSkeleton
